import React from "react";
import LogisticsCompanyNameMap from "@/map/LogisticsCompanyNameMap";
import WaybillTemplateTypeNameMap from "@/map/WaybillTemplateTypeNameMap";
import { useEwaybillAccountStore, useGlobalStore } from "@/store/hooks";
import { buildEwaybillAccountInfo } from "@/utils/EwaybillUtil";
import { observer } from "mobx-react-lite";
import EwaybillResultStore from "@/scenes/OrderManagement/components/dialogs/PrintEwaybillResultDialog/EwaybillResultStore";
import { MultiShopSelectPlatformType, MultiShopSelectPlatformTypeName } from "@/components/MultiShopSelect/types";

interface EwaybillPrintInfoProps {
    platform: MultiShopSelectPlatformType;

    store: EwaybillResultStore;

    copies?: string | number;
}

const EwaybillPrintInfo: React.FC<EwaybillPrintInfoProps> = function (props) {
    const { platform, store, copies } = props;

    const globalStore = useGlobalStore();
    const ewaybillAccountStore = useEwaybillAccountStore();

    const orderSize = store.orders.length;

    const ewaybillAccount = ewaybillAccountStore?.ewaybillAccountMapping?.get(store.template.ewaybillShippingAddressId);

    const { name, ewaybillTypeName } = buildEwaybillAccountInfo(ewaybillAccount, globalStore.shopMapping);

    const platformName = MultiShopSelectPlatformTypeName[platform];

    return (
        <div style={{ fontSize: 13, marginBottom: 10 }}>
            <p>
                <span>{platformName}模板:</span>
                <span>【{WaybillTemplateTypeNameMap[store.template.type]}】</span>
                <span>{store.template.name}</span>
                <span>({LogisticsCompanyNameMap[store.template.logisticsCompany]})</span>
                {name && ewaybillTypeName ? (
                    <span className="ml20">
                        电子面单账号:{name}({ewaybillTypeName})
                    </span>
                ) : null}
            </p>

            <p>
                <span>{platformName}</span>
                <span className="mr20">订单数：{orderSize}</span>
                <span className="mr20">打印份数：{copies}</span>
            </p>
        </div>
    );
};

export default observer(EwaybillPrintInfo);
